
import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'app/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { AbDownload } from 'app/abstract/full-pages/download/download.abstract';


@Injectable({ providedIn: 'root' })
export class DownloadService extends AbDownload {

  constructor(http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    super(http);
  }

  public downloadArquivoByBase64(base64: string, nomeAnexo: string): Observable<any> {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = nomeAnexo;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    window.URL.revokeObjectURL(downloadLink.href);
    document.body.removeChild(downloadLink);

    return observableOf(null);
  }

  public downloadArquivoByBlob(blob: Blob, nomeAnexo: string): Observable<any> {
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = nomeAnexo;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    window.URL.revokeObjectURL(downloadLink.href);
    document.body.removeChild(downloadLink);

    return observableOf(null);
  }

  public validarArquivo(files, limitUpload, arquivos): boolean {
    if (!(files && files.length > 0 && (files[0].type.includes("image") || files[0].type.includes("gif") ||
      files[0].type.includes("pdf") || files[0].type.includes("word") || files[0].type.includes("docx") || files[0].type.includes("spreadsheet")))) {
      this.toastr.warning(this.translate.instant("Tipo de arquivo inválido."))
      return false;
    }

    if (files && files.length > 0 && files[0].size > limitUpload) {
      this.toastr.warning(this.translate.instant('Arquivo maior que {{tamanho}}MB! Selecione um arquivo menor.', { tamanho: limitUpload / 1000000 }));
      return false;
    }

    if (files && files.length > 0 && arquivos.reduce((acc, a) => acc + a.file ? a.file.size : a.fileSize, 0) + files[0].size > limitUpload) {
      this.toastr.warning(this.translate.instant('Tamanho total dos anexos excede {{tamanho}}MB! Selecione um arquivo menor.', { tamanho: limitUpload / 1000000 }));
      return false;
    }

    let exists = false;
    arquivos.forEach(element => {
      if (element.nome == files[0].name) {
        this.toastr.warning(this.translate.instant('Já existe um arquivo com o nome {{nomeArquivo}} incluído na lista de arquivos!', { nomeArquivo: element.nome }));
        exists = true;
        return false;
      }
    });

    if (exists)
      return false;

    return true
  }

}
